var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActionPaperAirplane = function SvgActionPaperAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M2.996 7.451C1.815 6.27 2.652 4.25 4.323 4.25h15.55c1.459 0 2.36 1.59 1.607 2.84L13.233 20.84c-.872 1.454-3.07 1.096-3.438-.558L8.07 12.525 2.996 7.45ZM4.323 5.75a.375.375 0 0 0-.266.64l5.228 5.229c.101.1.171.228.202.367l1.77 7.97a.375.375 0 0 0 .689.111l8.249-13.749a.375.375 0 0 0-.321-.568H4.323Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M21.499 5.201a.75.75 0 0 1-.3 1.018l-12.09 6.59a.75.75 0 1 1-.718-1.317l12.09-6.59a.75.75 0 0 1 1.018.3",
    clipRule: "evenodd"
  })));
};
export default SvgActionPaperAirplane;